module.exports = __webpack_public_path__ + "static/media/Brightwind_Logo_Icon_Alt.edc469a4.png";